import { useQuery } from 'react-query';

import {
  TournamentByeArgsByOwner,
  TournamentByeResponse,
} from '~/../api/common.types';
import { api } from '~/client/api';

export const useGetTournamentByesByOwner = ({
  data,
  enabled,
}: {
  data: TournamentByeArgsByOwner;
  enabled: boolean;
}) => {
  return useQuery<TournamentByeResponse | undefined, Error>(
    ['tournament-byes', data, data.walletAddress],
    () => api.getTournamentByesByOwner(data),
    {
      enabled: enabled,
    }
  );
};
